import React, { useState, useEffect } from "react";
import { IonContent, IonPage, useIonViewWillEnter } from '@ionic/react';
import './Login.css';
import encabezado from '../asset/img/loginEncabezado.png';
import { InAppBrowser, InAppBrowserOptions  } from '@awesome-cordova-plugins/in-app-browser';
import env from '../env.json';
import ReactGA from "react-ga4";
import axios from "axios";

// --- Imports para el StatusBar ---
import { StatusBar } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';


const Login: React.FC = () => {

    // --- Lógica del color de la barra de estado ---
    useIonViewWillEnter(() => {
        const setStatusBarColor = async () => {
            if (Capacitor.isNativePlatform()) {
                // Establece el color azul oscuro para esta página
                await StatusBar.setBackgroundColor({ color: '#01019e' });
            }
        };
        setStatusBarColor();
    });
    // --- Fin de la lógica del color ---


    const url = env.REACT_APP_URL;
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const profile = async () => {
        const token = localStorage.getItem('token');
        const header = {
            'Authorization': 'Bearer ' + token
        }

        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        await instance.get('/api/profile')
        .then(res => {
            localStorage.setItem('profile', JSON.stringify(res.data));
        })
    }

    const login = async () => {

        const instance = axios.create({
            baseURL: url
        })

        await instance.post('/api/login', {
            "email" : email,
            "password": password
        })
        .then(async (res: any) => {
            console.log(res.data)
            
            if (res.data['error'] === "Reset") openWebview(url + '/reset_password');
            
            else {
                localStorage.setItem("token", res.data.plainTextToken)
                await profile();  
                window.location.href = '/'
            }
        })
        .catch(e => alert('Usuario y/o contraseña incorrectas'))
    }

    const updateEmail = (event:any) => {
        setEmail(event.target.value);
    }

    const updatePassword = (event:any) => {
        setPassword(event.target.value);
    }

    const openWebview = async (fullUrl: string) => {
        let options: InAppBrowserOptions = {location: 'yes', hideurlbar: 'yes'}
        let target = "_blank";
        InAppBrowser.create(fullUrl, target, options );
    };

    return(
        <IonPage>
            <header>
                <img src={encabezado} alt="" />
            </header>
            <IonContent>
                <div className="container login-inputs">
                    <input onChange={updateEmail} className="login-input" type="email" placeholder="Correo electronico" />
                    <br />
                    <input onChange={updatePassword} className="login-input" type="password" placeholder="Contraseña" />
                    <br />
                    <button className="btn iniciar-sesion" onClick={login}>Iniciar sesión</button>
                    <br />
                    <a className="links-login" onClick={() => openWebview(url + "/forgot-password")}>¿Olvidaste tu contraseña?</a>
                </div>
            </IonContent>
        </IonPage>
    );
    
}

export default Login;